export const templatesIndex = {
  header: {
    title: "قوالب واتساب",
    description:
      "أنشئ وحرّر القوالب تمامًا كما في Meta (header/body/footer/buttons + preview).",
    create: "إنشاء قالب",
  },
  notConnected:
    'حسابك لا يحتوي على واتساب للأعمال متصل (WABA). قم بالاتصال أولًا من "WhatsApp Business".',
  filters: {
    search: "بحث",
    searchPlaceholder: "البحث بالاسم...",
    status: "الحالة",
    all: "الكل",
    category: "الفئة",
    allFem: "الكل",
    language: "اللغة",
    refresh: "تحديث",
  },
  list: {
    loading: "جارٍ تحميل القوالب...",
    emptyTitle: "لا توجد قوالب",
    emptyText: "جرّب تغيير عوامل التصفية أو أنشئ أول قالب لك.",
    baseBadge: "أساسي",
    edit: "تعديل",
    duplicate: "تكرار",
    deleteProtected: "قالب أساسي: لا يمكن حذفه",
    delete: "حذف",
    prev: "→ السابق",
    next: "التالي ←",
  },
  preview: {
    noText: "(بدون نص)",
    noContent: "لا يوجد محتوى",
  },
  time: {
    now: "الآن",
    minutesAbbr: "{n} دقيقة",
    hoursAbbr: "{n} ساعة",
  },
  common: {
    close: "إغلاق",
    cancel: "إلغاء",
  },
  editor: {
    createTitle: "إنشاء قالب",
    editTitle: "تعديل قالب",
    sectionBasic: "أساسي",
    name: "الاسم (snake_case)",
    nameHintHtml:
      "تتحوّل المسافات إلى <code>_</code>. فقط <code>a-z</code> و<code>0-9</code> و<code>_</code>.",
    language: "اللغة",
    category: "الفئة",
    sectionHeader: "الترويسة",
    enable: "تفعيل",
    type: "النوع",
    headerLocationHintHtml:
      "لا تتضمّن ترويسة LOCATION نصًا أو أمثلة في القالب. يُرسَل الموقع (lat/lng + name/address) عند إرسال الرسالة عبر <code>/messages</code>.",
    headerMediaHint:
      "إذا استخدمت الوسائط (MEDIA)، فقد يتطلّب حسابك أمثلة/معرّفات أثناء المراجعة.",
    headerTextLabel: "النص (60 كحد أقصى)",
    headerTextPlaceholder: "مثال: مرحبًا {{1}}، حجزك جاهز.",
    insert: "إدراج",
    autoExample: "مثال تلقائي",
    examplesHeader: "أمثلة (الترويسة)",
    remove: "إزالة",
    headerLocationNote: "سيتم إرسال بطاقة خريطة في بداية الرسالة.",
    headerMediaNote: "ستظهر هذه الترويسة كمرفق (وسائط).",
    sectionBody: "المتن",
    bodyPlaceholder: "اكتب المحتوى. استخدم {{1}}، {{2}}...",
    examplesBody: "أمثلة (المتن)",
    sectionFooter: "التذييل",
    footerPlaceholder: "نص قصير (اختياري، 60 كحد أقصى)",
    sectionButtons: "الأزرار",
    addButton: "+ إضافة",
    noButtons: "لا توجد أزرار (اختياري).",
    buttonTextPlaceholder: "نص الزر (25 كحد أقصى)",
    removeButton: "حذف",
    previewTitle: "معاينة",
    viewPayload: "عرض الحمولة المُرسَلة إلى Meta",
    metaDebug: "استجابة / خطأ Meta (debug)",
    validReady: "جاهز للحفظ.",
    validIncomplete: "أكمل الحقول المطلوبة قبل الحفظ.",
    saving: "جارٍ الحفظ...",
    save: "حفظ",
  },
  delete: {
    title: "حذف القالب",
    irreversible: "لا يمكن التراجع عن هذا الإجراء.",
    willDeletePre: "سيتم حذف القالب ",
    willDeletePost: ".",
    confirmLabel: "اكتب الاسم بالضبط للتأكيد:",
    confirmPlaceholder: "اكتب الاسم تمامًا",
    confirmHint: "يتم تفعيل الزر عندما يتطابق النص تمامًا.",
    deleting: "جارٍ الحذف...",
    confirmDelete: "حذف نهائي",
  },
  errors: {
    nameRequired: "الاسم مطلوب.",
    nameInvalid: "تنسيق غير صالح. استخدم فقط a-z و0-9 و_.",
    headerRequired: "نص الترويسة مطلوب إذا كانت الترويسة مفعّلة.",
    headerMax: "نص الترويسة 60 حرفًا كحد أقصى.",
    bodyRequired: "المتن مطلوب.",
    bodyMax: "المتن 1024 حرفًا كحد أقصى.",
    footerMax: "التذييل 60 حرفًا كحد أقصى.",
    buttonTextRequired: "نص الزر مطلوب.",
    buttonTextMax: "25 حرفًا كحد أقصى.",
    phoneInvalid: "يجب أن يكون PHONE_NUMBER بصيغة E.164 (مثال: +34123456789).",
    urlInvalid: "يجب أن يبدأ عنوان URL بـ http:// أو https://",
    loadDetail: "تعذّر تحميل تفاصيل القالب.",
    save: "خطأ أثناء حفظ القالب.",
    deleteFailed: "تعذّر حذف القالب.",
  },
  duplicate: {
    defaultBody: "نسخة من القالب. حرّر المحتوى. شكرًا {{1}}.",
  },
};
